import { useState, useEffect, useContext, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import { DASHBOARD } from "../../utils/ConstantLinks";
import { useAuthContext } from "../../context/auth.context";
import { Spinner } from "react-bootstrap";
import Logo from "../../assets/images/cordeliaLogo1.png";
import BannerImg from "../../assets/images/bannerImg.webp";
import SnackbarContext from "../../context/snackbar.context";
import "./Login.scss"

const LoginForm = () => {
  const navigate = useNavigate();
  const snackbarCtx = useContext(SnackbarContext)
  const { onLogin, getOtp, loginLoading } = useAuthContext();

  const [activeInput, setActiveInput] = useState<1 | 2>(1); // 1 for email input and 2 for otp input
  const [email, setEmail] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [btnVis, setBtnVis] = useState<boolean>(false);
  const [seconds, setSeconds] = useState<number>(0);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  useEffect(() => {
    let interval: number;
  
    if (!btnVis) {
      interval = window.setInterval(() => {
        setSeconds((prevSec) => {
          if (prevSec === 1) {
            setBtnVis(true);
            clearInterval(interval);
          }
          return prevSec - 1;
        });
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [btnVis]);

  const handleGenerateOtp = async () => {
    const response = await getOtp(email);
    if (response.success || response?.data === 212) {
      setSeconds(30);
      setBtnVis(false);
      setActiveInput(2);
    }
    snackbarCtx.toggleSnackbar({ message: response?.message, type: `${response.success ? "SUCCESS" : "FAILURE"}`, visible: true });
  }

  const handleLogin = async () => {
    const response = await onLogin({
      email: email,
      otp: +otp,
    });
    response.success ? navigate(DASHBOARD) : snackbarCtx.toggleSnackbar({ message: response?.message, type: "FAILURE", visible: true });    
  };

  const handleFormSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!(email).match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      snackbarCtx.toggleSnackbar({ message: 'Invalid Email', type: "FAILURE", visible: true });
      return;
    }
    if (activeInput === 1) {
      handleGenerateOtp();
    } else if (activeInput === 2) {
      (+otp > 99999) ? handleLogin() : snackbarCtx.toggleSnackbar({ message: 'Invalid OTP', type: "FAILURE", visible: true });
    }
  }

  return (
    <div className="w-[100vw] h-[100vh] login-screen-wrapper">
      <img src={BannerImg} alt="Banner Image" />
      <div className="w-[300px] absolute top-1/2 left-[250px] -translate-x-1/2 -translate-y-1/2 z-10 flex flex-col items-center gap-14 bg-white px-4 py-16 rounded-3xl login-container-wrapper">
        <img src={Logo} alt="logo" width="100" />
        <form onSubmit={handleFormSubmit} className="w-full flex flex-col gap-4">
          <input
            type="text"
            name="email"
            id="email"
            className="w-full px-2 py-1 login-input "
            placeholder="Staff Email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value.trim());
            }}
          />
          {activeInput === 2 && <OtpInput
            value={otp}
            inputType="tel"
            onChange={(otp) => setOtp(otp)}
            numInputs={6}
            shouldAutoFocus={true}
            renderInput={(props) => <input {...props} />}
          />}
          <button className="w-full py-1.5 rounded text-white whitespace-nowrap submit-btn" type="submit" disabled={loginLoading}>
            {activeInput === 1 ? "Generate Email OTP" : "Login"}
            {loginLoading && <Spinner animation="border" size="sm" className="ml-2" />}
          </button>
        </form>
        {activeInput === 2 && (
          <button
            className="w-full py-1.5 -mt-8 rounded text-black bg-white border-1 whitespace-nowrap resend-btn"
            onClick={handleGenerateOtp}
            disabled={!btnVis}
          >
            <>
              {btnVis ? "Resend OTP" : "Wait "}
              <span>{!btnVis && `for ${formatTime(seconds)} sec`}</span>
            </>
          </button>
        )}
      </div>
    </div>
  );
};

export default LoginForm;
